const data = {
  counterText: 'Limited slots available',
  loading: 'Loading',
  next: 'Next',
  previous: 'Previous',
  smCounterText: 'Limited slots left.',
};

export default data;
